import React from "react";
import type { PropertyListProps } from "./BasePropertyList";
import PropertyList from "./BasePropertyList";
import FormSteps from "./FormSteps";
import type { MultipropBasePropertyInfo } from "../dealTypes";

type CreatePropertyListProps = Omit<
    PropertyListProps<MultipropBasePropertyInfo>,
    "children"
> & {
    onBack: () => void;
    onNext: () => Promise<void>;
};

export const CreatePropertyList: React.FC<CreatePropertyListProps> = ({
    onBack,
    onNext,
    ...props
}) => {
    return (
        <PropertyList<MultipropBasePropertyInfo> {...props}>
            {({ isSubmitDisabled }) => (
                <FormSteps
                    useSubNavbarIds={false}
                    onBack={onBack}
                    currentStep={2}
                    totalSteps={2}
                    editingProperty={false}
                    onNext={onNext}
                    isNextDisabled={isSubmitDisabled}
                />
            )}
        </PropertyList>
    );
};
